/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsDoubleLeft: {
  name: 'chevrons-double-left';
  data: string;
} = {
  name: 'chevrons-double-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.354 4.354a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L3.707 8l3.647-3.646Zm6 0a.5.5 0 0 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L9.707 8l3.647-3.646Z" fill="currentColor"/></svg>`,
};
